var Info = /** @class */ (function () {
    function Info() {
    }
    return Info;
}());
export { Info };
